export { default } from './AnchorLink';
export * from './AnchorLink';
